import { render } from "./FooterDisclaimer.vue?vue&type=template&id=12162f9c&scoped=true"
const script = {}

import "./FooterDisclaimer.vue?vue&type=style&index=0&id=12162f9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12162f9c"]])

export default __exports__